export const hasEmissionQuotationContext = (
  quotationId?: string,
  coverageSelected?: { request_id?: number; coverage_id?: number }
): boolean =>
  Boolean(quotationId || (coverageSelected?.request_id && coverageSelected?.coverage_id));

export type EmissionQuotationLookupStatus = "loading" | "available" | "unavailable";

export const getEmissionQuotationView = (
  quotationId?: string,
  coverageSelected?: { request_id?: number; coverage_id?: number },
  quotation?: { id: string },
  quotationLookupStatus: EmissionQuotationLookupStatus = "loading"
): "no-context" | "loading" | "unavailable" | "form" => {
  if (!hasEmissionQuotationContext(quotationId, coverageSelected)) return "no-context";
  if (!quotationId) return "form";
  if (quotationLookupStatus === "loading") return "loading";
  if (quotationLookupStatus === "unavailable" || !quotation || String(quotation.id) !== quotationId)
    return "unavailable";
  return "form";
};
